import { Arrow } from "./Arrow";
import { Badge } from "./Badge";
import { IntroFee } from "./IntroFee";
import { Subtitle } from "./Subtitle";
import { Title } from "./Title";
import { Value } from "./Value";
import { BadgeWithArrow } from "./WithArrow/BadgeWithArrow";
import { IntroFeeWithArrow } from "./WithArrow/IntroFeeWithArrow";
import { ValueWithArrow } from "./WithArrow/ValueWithArrow";

export const Price = Object.assign(Value, {
  Value,
  Badge,
  IntroFee,
  Arrow,
  Title,
  BadgeWithArrow,
  IntroFeeWithArrow,
  ValueWithArrow,
  Subtitle,
});
